import React, { useState, useEffect } from 'react';
import api from '../api';
import { ListSkeleton } from '../components/ui';

const DIRFLAG = {
  'Italia':'🇮🇹','DACH':'🇩🇪','Francia':'🇫🇷','Spagna':'🇪🇸',
  'Benelux':'🇳🇱','Est Europa':'🇨🇿',
  'ITA':'🇮🇹','DEU':'🇩🇪','FRA':'🇫🇷','ESP':'🇪🇸','NLD':'🇳🇱','CEE':'🇨🇿',
};

const LVL_COLOR = {
  'MASSIMO':'var(--cyan)','MOLTO ALTO':'var(--purple)','ALTO':'var(--yellow)',
  'Alto':'var(--yellow)','Medio-Alto':'var(--text-muted)',
};

const ST_BADGE = {
  IN_LISTA:   { bg:'var(--surface)',  color:'var(--text-muted)', label:'In lista' },
  nuovo:      { bg:'var(--surface)',  color:'var(--text-muted)', label:'In lista' },
  contattato: { bg:'rgba(0,212,255,0.12)', color:'var(--cyan)',  label:'Contattato' },
  in_trattativa:{ bg:'rgba(255,200,0,0.12)', color:'var(--yellow)', label:'In trattativa' },
  won:        { bg:'rgba(0,255,136,0.12)', color:'var(--green)', label:'Firmato ✓' },
  lost:       { bg:'rgba(255,80,80,0.12)', color:'var(--red)',   label:'Perso' },
};

function LeadTable({ leads }) {
  return (
    <div style={{ overflowX:'auto' }}>
      <table style={{ width:'100%', borderCollapse:'collapse', fontSize:12 }}>
        <thead>
          <tr style={{ background:'var(--bg3)', color:'var(--text-muted)', textAlign:'left' }}>
            {['Azienda','Città','Zona','Rating','Prestigio','Fatturato','Stato'].map(h => (
              <th key={h} style={{ padding:'8px 12px', fontWeight:600, whiteSpace:'nowrap', borderBottom:'1px solid var(--border)' }}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {leads.map(l => {
            const sb = ST_BADGE[l.stato] || ST_BADGE.nuovo;
            return (
              <tr key={l.id} style={{ borderBottom:'1px solid var(--border)' }}>
                <td style={{ padding:'9px 12px', fontWeight:600, color:'var(--text)' }}>{l.azienda || '—'}</td>
                <td style={{ padding:'9px 12px', color:'var(--text-muted)' }}>{l.citta || '—'}</td>
                <td style={{ padding:'9px 12px', color:'var(--text-muted)', fontSize:11.5 }}>{l.zona || '—'}</td>
                <td style={{ padding:'9px 12px', color:'var(--text-muted)' }}>{l.rating_val ? `★ ${l.rating_val}` : '—'}</td>
                <td style={{ padding:'9px 12px', color:LVL_COLOR[l.livello]||'var(--text-muted)', fontWeight:600, fontSize:11.5 }}>{l.livello || '—'}</td>
                <td style={{ padding:'9px 12px', color:'var(--text-muted)', fontSize:11.5 }}>{l.fatturato || '—'}</td>
                <td style={{ padding:'9px 12px' }}>
                  <span style={{ fontSize:11, padding:'2px 8px', borderRadius:20, background:sb.bg, color:sb.color, whiteSpace:'nowrap' }}>
                    {sb.label}
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

// ── DETTAGLIO DIRETTORE ───────────────────────────────────────────────────────
function DirettoreDetail({ direttore, onBack }) {
  const [allLeads, setAllLeads] = useState([]);
  const [clienteFilter, setClienteFilter] = useState('');

  useEffect(() => {
    api.get(`/leads/by_direttore/${encodeURIComponent(direttore.name)}`)
      .then(r => setAllLeads(Array.isArray(r.data) ? r.data : []))
      .catch(() => setAllLeads([]));
  }, [direttore.name]);

  const clienti = [...new Set(allLeads.map(l => l.cliente_b2b).filter(Boolean))];
  const visibili = clienteFilter ? allLeads.filter(l => l.cliente_b2b === clienteFilter) : allLeads;
  const flag = DIRFLAG[direttore.area] || '💼';

  return (
    <div style={{ padding:'clamp(16px, 4vw, 28px) clamp(16px, 4vw, 32px)', maxWidth:1200, margin:'0 auto' }}>
      <p style={{ fontSize:12.5, color:'var(--text-muted)', margin:'0 0 18px' }}>
        <span style={{ color:'var(--cyan)', cursor:'pointer' }} onClick={onBack}>← Direttori</span>
      </p>

      <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:6 }}>
        <span style={{ fontSize:34 }}>{flag}</span>
        <div>
          <h1 style={{ fontSize:22, fontWeight:700, color:'var(--text)', margin:0 }}>{direttore.name}</h1>
          <p style={{ fontSize:13, color:'var(--text-muted)', margin:'2px 0 0' }}>
            {direttore.area} · {direttore.n} lead · rating medio {direttore.avg_rating}★
          </p>
        </div>
      </div>

      {clienti.length > 0 && (
        <div style={{ display:'flex', alignItems:'center', gap:8, margin:'12px 0 16px' }}>
          <span style={{ fontSize:11, color:'var(--text-muted)' }}>Filtra per cliente B2B:</span>
          <select
            value={clienteFilter}
            onChange={e => setClienteFilter(e.target.value)}
            style={{ padding:'5px 10px', border:'1px solid var(--border)', borderRadius:7, fontSize:12, background:'var(--surface)', color:'var(--text)' }}
          >
            <option value="">Tutti i clienti B2B</option>
            {clienti.map(c => <option key={c} value={c}>{c}</option>)}
          </select>
        </div>
      )}

      <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:10, overflow:'hidden' }}>
        <LeadTable leads={visibili} />
      </div>
      <p style={{ fontSize:11.5, color:'var(--text-dim)', marginTop:8 }}>
        {visibili.length} lead{clienteFilter ? ` · cliente ${clienteFilter}` : ''}
      </p>
    </div>
  );
}

// ── LANDING DIRETTORI ─────────────────────────────────────────────────────────
export default function Direttori() {
  const [direttori, setDirettori] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/leads/direttori')
      .then(r => { setDirettori(Array.isArray(r.data) ? r.data : []); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  if (loading) return <ListSkeleton rows={5} />;

  if (selected) {
    return <DirettoreDetail direttore={selected} onBack={() => setSelected(null)} />;
  }

  return (
    <div className="eden-page">
      <h1 style={{ fontSize:22, fontWeight:700, margin:'0 0 4px', color:'var(--text)' }}>Direttori commerciali</h1>
      <p style={{ fontSize:13, color:'var(--text-muted)', margin:'0 0 22px' }}>
        Seleziona un direttore e apri il suo database (filtrabile per cliente B2B)
      </p>

      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(260px,1fr))', gap:14 }}>
        {direttori.map(d => {
          const flag = DIRFLAG[d.area] || '💼';
          return (
            <div key={d.name}
              onClick={() => setSelected(d)}
              style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:14, padding:'18px 20px', cursor:'pointer', transition:'border-color 0.15s, background 0.15s' }}
              onMouseEnter={e => { e.currentTarget.style.borderColor='rgba(0,212,255,0.4)'; e.currentTarget.style.background='var(--surface-h)'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor='var(--border)'; e.currentTarget.style.background='var(--surface)'; }}
            >
              <div style={{ fontWeight:700, fontSize:14, color:'var(--text)', marginBottom:2 }}>
                {flag} {d.name}
              </div>
              <div style={{ fontSize:12, color:'var(--text-muted)', marginBottom:12 }}>{d.area}</div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8 }}>
                <div style={{ background:'var(--bg3)', borderRadius:8, padding:'8px 12px', textAlign:'center' }}>
                  <div style={{ fontWeight:700, fontSize:16, color:'var(--text)' }}>{d.n}</div>
                  <div style={{ fontSize:10, color:'var(--text-muted)' }}>lead</div>
                </div>
                <div style={{ background:'var(--bg3)', borderRadius:8, padding:'8px 12px', textAlign:'center' }}>
                  <div style={{ fontWeight:700, fontSize:16, color:'var(--yellow)' }}>{d.avg_rating}★</div>
                  <div style={{ fontSize:10, color:'var(--text-muted)' }}>rating medio</div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
